import { runtimeEnv } from "config/runtimeEnv";
import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "utils/utils";

let env = runtimeEnv("API_BASE_URL")

export const rateCardApi = async(data) => {
  let url = `${env}${API_ENDPOINT.RateCard.api}?carType=${data?.carId}&type=${data?.type}&baseFuelPrice=${data?.baseFuelPrice}&location=${data?.location}`
  const res = await requestInstance.get(
    url,data
  )
  .catch((err) => err.response)
  return setCurrentUser(res)
}
export const postRateCardApi = async(data) => {
  const res = await requestInstance.post(
    `${env}${API_ENDPOINT.RateCard.api}`,data
  )
  .catch((err) => err.response)
  return setCurrentUser(res)
}
export const baseFuelApi = async(data) => {
  let url = `${env}${API_ENDPOINT.RateCard.baseFuelApi}?location=${data?.location}`
  const res = await requestInstance.get(
    url,data
  )
  .catch((err) => err.response)
  return setCurrentUser(res)
}

